/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC20TransferTier,
  ERC20TransferTierInterface,
} from "../ERC20TransferTier";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_size",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "InvalidCodeAtRange",
    type: "error",
  },
  {
    inputs: [],
    name: "WriteError",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "erc20",
        type: "address",
      },
    ],
    name: "Initialize",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pointer",
        type: "address",
      },
    ],
    name: "InitializeValueTier",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startTier",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTier",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "TierChange",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20",
            name: "erc20",
            type: "address",
          },
          {
            internalType: "uint256[8]",
            name: "tierValues",
            type: "uint256[8]",
          },
        ],
        internalType: "struct ERC20TransferTierConfig",
        name: "config_",
        type: "tuple",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address",
      },
    ],
    name: "report",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "endTier_",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data_",
        type: "bytes",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tierValues",
    outputs: [
      {
        internalType: "uint256[8]",
        name: "tierValues_",
        type: "uint256[8]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC20TransferTierConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC20TransferTierConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC20TransferTier__factory extends ContractFactory {
  constructor(...args: ERC20TransferTierConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC20TransferTier> {
    return super.deploy(overrides || {}) as Promise<ERC20TransferTier>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC20TransferTier {
    return super.attach(address) as ERC20TransferTier;
  }
  connect(signer: Signer): ERC20TransferTier__factory {
    return super.connect(signer) as ERC20TransferTier__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC20TransferTierInterface {
    return new utils.Interface(_abi) as ERC20TransferTierInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC20TransferTier {
    return new Contract(address, _abi, signerOrProvider) as ERC20TransferTier;
  }
}
